<ifc-base-dialog
  [title]="(data.status | enumValueLabel: TransactionStatus : TransactionStatusVerb) + ' transaction?'"
  [actions]="actions"
  (actionClicked)="onActionClicked($event)"
>
  <ng-template #content>
    <p *ngIf="data.status !== TransactionStatus.Pending && !showWarning">
      You are updating {{ data.loanNumber }}’s transaction status to '{{
        data.status | enumValueLabel: TransactionStatus : TransactionStatusLabel | lowercase
      }}'.
    </p>
    <div *ngIf="showWarning">
      <p>
        The following conditions have not been met. Provide a reason for each unmet condition to proceed with the
        transaction update.
      </p>
      <div *ngFor="let group of drawRequirementGroups">
        <p><strong>{{ group.title }}</strong></p>
        <ul>
          <li *ngFor="let item of group.items" [innerHTML]="item"></li>
        </ul>
      </div>
    </div>
    <p *ngIf="data.status === TransactionStatus.Pending">
      You are updating {{ data.loanNumber }}’s transaction
      {{ data.status | enumValueLabel: TransactionStatus : TransactionStatusLabel | lowercase }} status.
    </p>

  <div *ngIf="data.status === TransactionStatus.OnHold" class="info">
    <mat-form-field appearance="outline">
      <mat-label>Expected Status</mat-label>
      <mat-select matInput [formControl]="form.get('nextStatus')" placeholder="Expected Status">
        <mat-option *ngFor="let option of TransactionNextStatusOptions" [value]="option.value">
          {{option.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div *ngIf="(showRejectReasons$ | async)" class="info">
    <p>To proceed, select reject reason(s).</p>
    <ifb-transaction-reject-input [fc]="form.get('reasons')" [usage]="FailureReasonUsage.ResidualUnderwriting"></ifb-transaction-reject-input>
    <ifb-competitors-select-search *ngIf="canReadCompetitors && (isCompetitorsSpecifiable$ | async)"
      [required]="true"
      [selectedCompetitorIds]="form.get('competitors').value"
      (competitorsChange)="onCompetitorsChange($event)">
    </ifb-competitors-select-search>
  </div>

  <div *ngIf="data.status === TransactionStatus.Declined" class="info">
    <p>To proceed, select decline reason(s).</p>
    <ifb-transaction-reject-input [fc]="form.get('reasons')" [usage]="FailureReasonUsage.NACHAResponse"></ifb-transaction-reject-input>
  </div>

    <div *ngIf="data.status === TransactionStatus.Pending" class="info">
      <p>To proceed, select pending reason(s).</p>
      <ifb-transaction-reject-input
        [fc]="form.get('reasons')"
        [usage]="FailureReasonUsage.PendingReason"
      ></ifb-transaction-reject-input>
    </div>
    <div *ngIf="showNotes" class="transaction-notes">
      <h4 class="transaction-notes__title">Notes</h4>
      <div *ngIf="existingNotes.length === 0" class="transaction-notes__empty">No notes on file.</div>
      <div *ngIf="existingNotes.length" class="transaction-notes__list">
        <div class="transaction-note" *ngFor="let note of existingNotes">
          <div class="transaction-note__meta">{{ note.date | date: 'medium' }} · {{ note.author }}</div>
          <div class="transaction-note__text">{{ note.text }}</div>
        </div>
      </div>
    </div>
    <div>
      <ifb-note-card [fc]="form.get('note')" [hideButtons]="true" [showNotes]="false"></ifb-note-card>
    </div>
  </ng-template>
</ifc-base-dialog>
